import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3cd9ef7xf: FaireProductEntity = {
  token: "p_x3cd9ef7xf",
  type: "product",
  name: "Banana Cream",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/6801e6c60d6a9bddb798c58b2626e747a94b374bf36e4bc18296341c1b07fc04.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6f66f39f771b335d9eadf274722ee944278a8270a6b25605ad69f5e44bf0a49.jpeg",
    "https://cdn.faire.com/fastly/ffba67a09679f311a77867e9cb0295f5d3d719529324a23294cdd83682694c8a.jpeg",
    "https://cdn.faire.com/fastly/bb1a68a40889d62f35766dd9c0a908d12791c68788f72e2677ec91909bda4090.jpeg",
    "https://cdn.faire.com/fastly/db636753b8f01b4256323796e9e5f00b5583d817056ce6a912d706de4ccb3465.jpeg",
    "https://cdn.faire.com/fastly/5423bd77ed2108bde2ffe42aa53b51e178d5e8b9bd3464a9973045e6363f9e99.jpeg",
  ],
  priceDollars: 28.99,
  description:
    "A flavor unlike any other we’ve created before, this surprisingly delightful soda melds creamy vanilla and sweet banana together for a taste best described as banana cream pie in a can.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:14.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
